// extracted by mini-css-extract-plugin
module.exports = {"timer":"_12655","item":"_3086","divider":"_577"};